import { createSelector } from '@reduxjs/toolkit';
import { Field } from 'api/tasks';
import { STATUS_FIELD_NAME } from 'data/fields/hooks/account-fields';
import { byFieldName } from 'utils/by-field-name';
import { RootState } from '../index';

export const selectTaskStatusField = ({
  taskFields,
}: RootState): Required<Field> => {
  const { fields } = taskFields;

  const field = fields.find((f) => byFieldName(f, STATUS_FIELD_NAME));

  if (!field) {
    throw new Error('Status field is missing');
  }

  return field as Required<Field>;
};

export const selectTaskStatusFieldDefaultValue = createSelector(
  selectTaskStatusField,
  (field) => field.metaData.default,
);
